import { WSService } from "../../utils/WSService";

export const serviceUser = new WSService("/users");
